export enum CustomTableFilterMatchers {
  FormattedDateMatcher = 'formattedDateMatcher',
  FormattedNumericMatcher = 'formattedNumericMatcher',
}
